import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./base-query";

export const api = createApi({
  reducerPath: "api",
  tagTypes: [
    "Therapist",
    "user",
    "Consent",
    "language",
    "sessionSummary",
    "admin",
    "GoogleCalendarStatus",
    "GoogleCalendarEvents",
    "TreatmentRooms",
    "TreatmentGroups",
    "PatientExerciseAssignments",
    "PaymentToken",
    "Questionnaires",
    "UserComments",

    "AppointmentSeries",
    "AppointmentProgramSessions",
  ],
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
});
